import React, { useState } from 'react';
import Foto from '../assets/profile-pic.png'
import './sidebar.css'
import { SidebarData } from '../SidebarData/sidebarData.js'
import { SidebarLinks} from '../SidebarData/sidebarLinks.js'
function Sidebar() {
    const [isActive, setIsActive] = useState(false);

    const handleActive = current =>{
        setIsActive(current => ! current)
    }
    return (
        <aside>
            <div id='hamburguer' className={isActive ? "mobile-active": "menu-mobile"} onClick={handleActive}>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <img src={Foto} className="sidebarImg"
            alt="foto de matheus dono do site"
            width="50px"/>
            <ul className={isActive ? "mobile": "sidebarList"}>
            {SidebarData.map((val,key) => {
            return (
                <li 
                key={key}
                className='row'
                id={window.location.pathname === val.link ? "active" : ""}
                onClick={() => {
                    window.location.pathname = val.link;
                }}>
                    {val.icon}
                    <h5 className='title'>{val.title}</h5>
                    
                </li>
            )
        })}
            </ul>
        <section className='sidebarList'>
            {SidebarLinks.map((val,key) => {
                return(
                    <a key={key} href={val.link}
                    target="_blank" rel="noreferrer noopener"
                    className='row'>
                        <div id='icon'>{val.icon}</div>
                    </a>
                )
            })}
        </section>

    </aside>
    );
}

export default Sidebar;